import React, { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'react-bootstrap';
import usePrivileges from '../../../Auth/usePrivileges';
import { LotDetailContext } from '../../../Contexts/LotDetailContext';

import CancelLotSplitDialog from '../../LotSplit/CancelLotSplitDialog';

function CancelSplitLotButton() {

    const { t } = useTranslation();

    const {
        lotDetail: {
            summary: {
                lotNumber,
                businessUnitCode,
                currentStatus,
                processingStatus,
                isLocked,
                isSplitLotParent
            }
        },
        getLotDetail,
        lotFlags: {
            canLotSplit
        }
    } = useContext(LotDetailContext);

    const { canReview } = usePrivileges(businessUnitCode);

    const [disabled, setDisabled] = useState<boolean>(false);
    const [showCancelLotSplitDialog, setShowCancelLotSplitDialog] = useState<boolean>(false);

    useEffect(() => {
        switch (true) {
            case processingStatus === "Queued":
            case processingStatus === "Processing":
            case currentStatus === "Importing":
            case currentStatus === "Pending":
            case currentStatus === "ReadyToGrade":
                setDisabled(true);
                break;
            default:
                setDisabled(false);
        }

        if (isLocked) {
            setDisabled(true);
        }

    }, [currentStatus, processingStatus, isLocked]);

    return (
        <>
            <Button variant="primary"
                onClick={() => setShowCancelLotSplitDialog(true)}
                disabled={disabled || !canReview}
                hidden={currentStatus === "Graded" || !isSplitLotParent || !canLotSplit}>
                {t('LotDetails.Summary.UndoSplit')}
            </Button>
            <CancelLotSplitDialog
                showDialog={showCancelLotSplitDialog}
                closeDialog={() => setShowCancelLotSplitDialog(false)}
                lotNumber={lotNumber}
                getLotDetail={getLotDetail} />
        </>
    );
}

export default CancelSplitLotButton;